import { z } from "zod";

export const permissionCreateSchema = z.object({
  action: z.string().min(1, "Action is required"),
});

export const permissionUpdateSchema = z.object({
  action: z.string().min(1, "Action is required"),
});

export type PermissionCreateFormData = z.infer<typeof permissionCreateSchema>;
export type PermissionUpdateFormData = z.infer<typeof permissionUpdateSchema>;

export interface Permission {
  id: string;
  action: string;
  created_at?: string;
  updated_at?: string;
}
